import { Toaster as T } from 'sonner';

export function Toaster({ position = 'top-right' }) {
  return (
    <T
      className="pointer-events-auto"
      position={position}
      theme="light"
      richColors
      toastOptions={{
        classNames: {
          toast: 'flex items-center space-x-1 px-3 py-2',
          title: 'text-sm font-hmedium'
          // description: 'text-red-400',
          // actionButton: 'bg-zinc-400',
          // cancelButton: 'bg-orange-400',
          // closeButton: 'bg-lime-400'
        }
      }}
    />
  );
}
